/**
 * Generates a UUID v4 compatible string.
 * Uses crypto.randomUUID() when available (secure context),
 * falls back to a Math.random() based implementation otherwise.
 */
export function generateUUID(): string {
  // Try to use crypto.randomUUID() if available (requires secure context)
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    try {
      return crypto.randomUUID();
    } catch (error) {
      // Fallback if randomUUID throws (e.g., in non-secure context)
      console.warn('[UUID] crypto.randomUUID() failed, using fallback:', error);
    }
  }

  // Fallback implementation for non-secure contexts (HTTP, IP addresses)
  // Based on RFC 4122 version 4 UUID format
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
